<template>
    <table class="table timeline-details-content">
        <tbody>
            <column-row v-for="row in table.data" :row="row" :columns="2" :key="row.$internalId">
                <template slot-scope="{row: {attribute, value}}">
                    <td class="text-muted" width="50%">
                        <attribute-name :name="attribute"/>
                    </td>
                    <td>
                        <attribute-value :name="attribute" :value="value"/>
                    </td>
                </template>
            </column-row>
        </tbody>
    </table>
</template>

<script>
    import AttributeValue from './attribute-value';
    import AttributeName from './attribute-name';
    import ColumnRow from './column-row';

    export default {
        name: 'two-column-list',
        components: {AttributeValue, AttributeName, ColumnRow},
        props: {
            table: Object,
        },
    };
</script>
